module.exports = __webpack_public_path__ + "static/media/46.bf962e44.svg";